import { render, staticRenderFns } from "./SurveyDashboard.vue?vue&type=template&id=35e0b7e1&"
import script from "./SurveyDashboard.vue?vue&type=script&lang=ts&"
export * from "./SurveyDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
